module.exports = __webpack_public_path__ + "static/media/CDocs.604bb791.png";